const EVERGREEN_OPTIONS = {
    EVERGREEN: 'Evergreen',
};

export default EVERGREEN_OPTIONS;
